export const LIGHT_VEHICLE_FSL_MULTIPLIER = 9.53;
export const HEAVY_VEHICLE_FSL_MULTIPLIER = 11.95;
export const MATERIAL_DAMAGE_FSL_MULTIPLIER = 11.95;
export const HOME_INSURANCE_FSL_DEFAULT = 119.50;
export const CONTENTS_INSURANCE_FSL_DEFAULT = 23.90;

export const HOME_INSURANCE_NHI_DEFAULT = 480.00;

export const SOA_MULTIPLIER = 10000;
